import React, { useState, useEffect } from "react";
import { fetchDailyData } from "../../api";
import { Line, Bar } from "react-chartjs-2";

import styles from "./Chart.module.css";

const Chart = ({
  data: { confirmed, recovered, deaths, incidentRate },
  country,
}) => {
  const [dailyData, setDailyData] = useState([]);

  // To automatically display the data
  useEffect(() => {
    const fetchAPI = async () => {
      setDailyData(await fetchDailyData());
    };
    // console.log(dailyData);
    fetchAPI();
  }, []);

  // Line Chart Component and the dailyData
  const lineChart = dailyData.length ? (
    <Line
      data={{
        labels: dailyData.map(({ date }) => date),
        datasets: [
          {
            data: dailyData.map(({ confirmed }) => confirmed),
            label: "Infected",
            borderColor: "#3333ff",
            fill: true,
          },
          {
            data: dailyData.map(({ deaths }) => deaths),
            label: "Deaths",
            borderColor: "red",
            backgroundColor: "rgba(255, 0, 0, 0.5)",
            fill: true,
          },
          // {
          //   data: dailyData.map(({ incidentRate }) => incidentRate),
          //   label: "Incident Rate",
          //   borderColor: "green",
          //   backgroundColor: "rgba(0, 255, 0, 0.5)",
          //   fill: true,
          // },
        ],
      }}
    />
  ) : null;

  console.log(confirmed, recovered, deaths);

  // Bar Chart Component and the data from props
  const barChart = confirmed ? (
    <Bar
      data={{
        labels: ["Infected", "Recovered", "Deaths"],
        datasets: [
          {
            label: "People",
            backgroundColor: [
              "rgba(0, 0, 255, 0.701)",
              "rgba(0, 255, 0, 0.65)",
              "rgba(255, 0, 0, 0.701)",
            ],
            data: [confirmed.value, recovered.value, deaths.value],
          },
        ],
      }}
      options={{
        legend: { display: false },
        title: { display: true, text: `Current State in ${country}` },
      }}
    />
  ) : null;

  return (
    <div className={styles.container}>{country ? barChart : lineChart}</div>
  );
};

export default Chart;
